<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Dipendenti</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Dipendenti</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->
</div>


<div class="content-block">


  <section class="col-lg-12 ">

    <div class="card primary">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
          Import dati dipendenti

        </h3>

        <div style="float:right;">
          <dx-button icon="arrowleft" stylingMode="contained" type="default" text="Esci"
            (onClick)="onEsciClick()">
          </dx-button>
        </div>

      </div><!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-xl-4 col-lg-6 col-12">
            <dx-button icon="exportxlsx" text="Scarica file Esempio" class="default"
              (onClick)="onScaricaFileEsempioClick()">
            </dx-button>
          </div>
          <div class="col-xl-8 col-lg-6 col-sm-12 col-xs-12 mb-6">
            <div class="row dx-field">
              <div class="dx-field-label col-2">File da importare:</div>
              <div class="dx-field-value col-4">
                <dx-file-uploader #fileUploader [multiple]="false" accept=".csv, .xlsx, .xls" [(value)]="fileValue"
                  uploadMode="useForm">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Selezionare il file">
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-file-uploader>
              </div>
            </div>
            <div class="row dx-field">
              @if (fileValue?.length > 0) {
                <div class="dx-field-label col-md-2 col-lg-4"></div>
              }
              <div class="col-6">
                @if (fileUploader.value?.length > 0) {
                  <div>
                    <dx-button icon="fa fa-upload" text="Carica" class="pulsante-azione"
                      (onClick)="allegaFile($event, fileUploader.value)">
                    </dx-button>
                  </div>
                }
              </div>
            </div>
            @if (importResult && fileValue?.length == 0) {
              <div class="row">
                <div class="col-12">
                  <h4>Esito importazione</h4>
                  <p>
                    Righe dipendenti trovate: {{importResult?.righeTrovate}}<br />
                    Righe dipendenti inserite: {{importResult?.righeInserite}}<br />
                    Righe dipendenti aggiornate: {{importResult?.righeAggiornate}}
                  </p>
                  @if (importResult?.listaErrori && importResult?.listaErrori.length > 0) {
                    <dx-list
                      [dataSource]="importResult?.listaErrori">
                    </dx-list>
                  }
                  @if (!importResult?.listaErrori || importResult?.listaErrori.length == 0) {
                    <p>
                      Non si sono verificati errori.
                    </p>
                  }
                </div>
              </div>
            }
          </div>
        </div>

      </div><!-- /.card-body -->
    </div>
    <!-- /.card -->

  </section>
</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>